import script from "./SGP4.vue?vue&type=script&setup=true&lang=js"
export * from "./SGP4.vue?vue&type=script&setup=true&lang=js"

import "./SGP4.vue?vue&type=style&index=0&id=08ba897e&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08ba897e"]])

export default __exports__